<form #f="ngForm" [formGroup]="phoneForm">
  <ngx-intl-tel-input
    [cssClass]="'form-control'"
    [preferredCountries]="preferredCountries"
    [enableAutoCountrySelect]="true"
    [customPlaceholder]="placeholder"
    [enablePlaceholder]="true"
    [searchCountryFlag]="true"
    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
    [selectFirstCountry]="false"
    [selectedCountryISO]="defaultContry"
    [maxLength]="15"
    [phoneValidation]="true"
    [separateDialCode]="separateDialCode"
    name="phone"
    formControlName="phone"
    (countryChange)="countryChange($event)"
    appPhoneMask
    [countryCode]="selectedCountryCode"
  ></ngx-intl-tel-input>
</form>
